function s(t) {
  var e = this.__data__, a = e.delete(t);
  return this.size = e.size, a;
}
var r = s;
export {
  r as _
};
